/*eslint-disable no-whitespace-before-property */
class MemberCoverageSummary {
  constructor() {
    this.selectedItem = 0;
    this.plansEnrolled = 0;
    this.benefitPlan = [];
    this.coverageType = [];
    this.memberCoverage = [];
    this.accumulatorDetails = [];

    this.coverageListItem = [];
    this.coverageList = [];
    this.coverageInfo = [];
    this.listShow = 0;
    this.listLen = 0;
    this.dispList = 'Show More';
    this.prevName = '';

    this.benefitCoverage = [];
    this.returnFlag = false;
  }

  getSelectedItem() {
    return this.selectedItem;
  }

  setSelectedItem(selectedItem) {
    this.selectedItem = selectedItem;
  }

  getPlansEnrolled() {
    return this.plansEnrolled;
  }

  setPlansEnrolled(plansEnrolled) {
    this.plansEnrolled = plansEnrolled;
  }

  getBenefitPlan(memberSeqID, iIndex) {
    return this.benefitPlan[memberSeqID][iIndex];
  }

  setBenefitPlan(memberSeqID, iIndex, benefitPlan) {
    this.benefitPlan[memberSeqID][iIndex] = benefitPlan;
  }

  getCoverageType(memberSeqID, iIndex) {
    return this.coverageType[memberSeqID][iIndex];
  }

  setCoverageType(memberSeqID, iIndex, coverageType) {
    this.coverageType[memberSeqID][iIndex] = coverageType;
  }

  getCoverageInfo(iIndex) {
    return this.coverageInfo[iIndex];
  }

  setCoverageInfo(iIndex, coverageInfo) {
    this.coverageInfo[iIndex] = coverageInfo;
  }

  getMemberCoverage(memberSeqID) {
    return this.memberCoverage[memberSeqID];
  }

  setMemberCoverage(memberSeqID, memberCoverage) {
    this.memberCoverage[memberSeqID] = memberCoverage;
  }

  getAccoumulatorDetails(memberSeqID) {
    return this.accumulatorDetails[memberSeqID];
  }

  setAccoumulatorDetails(memberSeqID, accumulatorDetails) {
    this.accumulatorDetails[memberSeqID] = accumulatorDetails;
  }

  getBenefitCoverage() {
    return this.benefitCoverage;
  }

  setBenefitCoverage(benefitCoverage) {
    this.benefitCoverage = benefitCoverage;
  }

  setReturnFlag(returnFlag) {
    this.returnFlag = returnFlag;
  }

  getReturnFlag() {
    return this.returnFlag;
  }

  resetMemberCoverageSummary() {
    this.selectedItem = 0;
    this.plansEnrolled = 0;
    this.benefitPlan = [];
    this.coverageType = [];
    this.memberCoverage = [];
    this.accumulatorDetails = [];

    this.coverageListItem = [];
    this.coverageList = [];
    this.coverageInfo = [];
    this.listShow = 0;
    this.listLen = 0;
    this.dispList = 'Show More';
    this.prevName = '';

    this.benefitCoverage = [];
    this.returnFlag = false;
  }
}

export default new MemberCoverageSummary();
